"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDefinitionToIconElement = renderDefinitionToIconElement;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utils = require("./utils");

var _config = require("./config");

var _classnames = _interopRequireDefault(require("classnames"));

var _stylenames = _interopRequireDefault(require("stylenames"));

var _excluded = ["style", "class"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function renderDefinitionToIconElement(iconDefinition) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.warning)((0, _utils.isIconDefinition)(iconDefinition), "icon should be icon definiton, but got ".concat(iconDefinition));

  if (!(0, _utils.isIconDefinition)(iconDefinition)) {
    return '';
  }

  (0, _utils.useInsertStyles)();
  var spin = options.spin,
      rotate = options.rotate,
      tabIndex = options.tabIndex,
      twoToneColor = options.twoToneColor,
      className = options["class"],
      _options$style = options.style,
      style = _options$style === void 0 ? '' : _options$style,
      _options$extraSVGAttr = options.extraSVGAttrs,
      extraSVGAttrs = _options$extraSVGAttr === void 0 ? {} : _options$extraSVGAttr;
  var parentCls = (0, _classnames["default"])(_config.componentOptions.cssNamespace, (0, _defineProperty2["default"])({}, "".concat(_config.componentOptions.cssNamespace, "-").concat(iconDefinition.name), Boolean(iconDefinition.name)), className);
  var parentSty = typeof style === 'string' ? style : (0, _stylenames["default"])(style);
  var iconTabIndex = tabIndex;
  var parentAttrs = {
    role: 'img',
    'aria-label': iconDefinition.name,
    tabindex: iconTabIndex,
    "class": parentCls,
    style: parentSty
  };
  var attrsToken = (0, _utils.optionsToAttrsToken)(parentAttrs);

  var _normalizeTwoToneColo = (0, _utils.normalizeTwoToneColors)(twoToneColor),
      _normalizeTwoToneColo2 = (0, _slicedToArray2["default"])(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  var _extraSVGAttrs$style = extraSVGAttrs.style,
      extraSvgSty = _extraSVGAttrs$style === void 0 ? '' : _extraSVGAttrs$style,
      _extraSVGAttrs$class = extraSVGAttrs["class"],
      extraSvgCls = _extraSVGAttrs$class === void 0 ? '' : _extraSVGAttrs$class,
      _extraSVGAttrs = (0, _objectWithoutProperties2["default"])(extraSVGAttrs, _excluded);

  var _extraSvgSty = typeof extraSvgSty === 'string' ? extraSvgSty : (0, _stylenames["default"])(extraSvgSty);

  var svgCls = (0, _classnames["default"])((0, _defineProperty2["default"])({}, "".concat(_config.componentOptions.cssNamespace, "-spin"), !!spin), extraSvgCls);
  var svgStyle = rotate ? "".concat((0, _stylenames["default"])({
    '-ms-transform': "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  })).concat(_extraSvgSty) : _extraSvgSty;
  var helpOptions = {
    placeholders: {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor
    },
    extraSVGAttrs: _objectSpread(_objectSpread({
      "class": svgCls,
      style: svgStyle
    }, _extraSVGAttrs), _utils.svgBaseProps)
  };
  var svg = (0, _utils.renderIconDefinitionToSVGElement)(iconDefinition, helpOptions);
  return "<span".concat(attrsToken, ">").concat(svg, "</span>");
}